import { useEffect, useRef } from "react";
import s from "./guide.module.css";

const text = (n) => (typeof n === "string" ? n : (n.k || []).map(text).join(" "));
// The next section's own approved headline doubles as its preview line (no new copy).
const headline = (sec) => {
  const h = sec?.blocks?.find((b) => b.t === "h2" || b.t === "h1");
  return h ? text(h).replace(/\s+/g, " ").trim() : "";
};

// Bottom step navigation through the guide's own sections (never other subjects); sits directly above Sources.
export function SectionPager({ nav, page, go, sections, onEnd, endText }) {
  const i = Math.max(0, nav.findIndex((t) => t.id === page));
  const prev = nav[i - 1];
  const next = nav[i + 1];
  const click = (t, forward) => (e) => { e.preventDefault(); go(t.id, forward); };
  const end = useRef(null);
  // Reaching the "End of guide" panel finishes the last section.
  useEffect(() => {
    if (next || !end.current) return;
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { onEnd(); io.disconnect(); } }, { threshold: 0.6 });
    io.observe(end.current);
    return () => io.disconnect();
  }, [next, page]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <nav className={s.pager} aria-label="Guide sections: previous and next" data-testid="student-pager">
      <p className={s.pagerCounter} data-testid="student-pager-count">Section {i + 1} of {nav.length}: {nav[i].label}</p>
      {next ? (
        <a href={`#${next.id}`} className={s.pagerNextCard} onClick={click(next, true)} data-testid="student-pager-next">
          <span className={s.pagerNextLabel}>Up next · Section {i + 2} of {nav.length}</span>
          <span className={s.pagerNextTitle}>Next: {next.label}<span aria-hidden="true" className={s.pagerArrow}>→</span></span>
          {headline(sections[next.id]) && <span className={s.pagerNextTeaser} data-testid="student-pager-next-teaser">{headline(sections[next.id])}</span>}
        </a>
      ) : (
        <div className={s.pagerEnd} ref={end} data-testid="student-pager-end">
          <span className={s.pagerNextTitle}>End of guide</span>
          <span className={s.pagerEndText}>You have reached the last section. {endText}</span>
        </div>
      )}
      <div className={s.pagerRow}>
        {prev ? <a href={`#${prev.id}`} className={s.pagerPrevLink} onClick={click(prev)} data-testid="student-pager-prev"><span aria-hidden="true">←</span> Previous: {prev.label}</a> : <span />}
        {!next && <a href={`#${nav[0].id}`} className={s.pagerPrevLink} onClick={click(nav[0])} data-testid="student-pager-restart">Back to the start: {nav[0].label}</a>}
      </div>
    </nav>
  );
}
